import { useEffect } from 'react';

export function usePendingOversizeFlush(
  sizeSavedAt: number,
  portfolioSize: number,
  isPortfolioSizeLocked: boolean,
  setOverrides: React.Dispatch<React.SetStateAction<Record<string, number>>>,
  handleUpdateAllocationByValue: (
    allocationId: string,
    dollarValue: number,
    newSize: number,
    isPortfolioSizeLocked: boolean,
    updatePortfolioSize: (size: number) => Promise<boolean>
  ) => Promise<void>,
  updatePortfolioSize: (size: number) => Promise<boolean>
) {
  useEffect(() => {
    if (!sizeSavedAt) return;
    try {
      const raw = sessionStorage.getItem('portfolio-pending-oversize');
      if (!raw) return;
      const pending = JSON.parse(raw || '{}');
      if (!pending || pending.expires < Date.now()) {
        sessionStorage.removeItem('portfolio-pending-oversize');
        return;
      }
      const { allocationId, dollarValue } = pending || {};
      const newSize = portfolioSize || 0;
      if (!allocationId || !Number.isFinite(Number(dollarValue)) || newSize <= 0) {
        sessionStorage.removeItem('portfolio-pending-oversize');
        return;
      }
      const pctAtNewSize = (Number(dollarValue) / newSize) * 100;
      setOverrides((prev) => ({ ...prev, [allocationId]: pctAtNewSize }));

      (async () => {
        try {
          await handleUpdateAllocationByValue(
            allocationId,
            Number(dollarValue),
            newSize,
            isPortfolioSizeLocked,
            updatePortfolioSize
          );
        } finally {
          try { sessionStorage.removeItem('portfolio-pending-oversize'); } catch {}
          try { sessionStorage.removeItem('portfolio-overflow-autosizing'); } catch {}
        }
      })();
    } catch {
      // ignore JSON/session errors
    }
  }, [sizeSavedAt, portfolioSize, isPortfolioSizeLocked, setOverrides, handleUpdateAllocationByValue, updatePortfolioSize]);
}
